// extracted by mini-css-extract-plugin
export default {"notices":"notices_notices__SR5gl"};